import React from 'react';
import './IntegratedCoverage.css';

const IntegratedCoverage = () => {
  return (
     <section id="integrated-coverage" className="coverage-section">
      <div className="container coverage-content">
        <h2>Integrated coverage across the supply chain</h2>
        <p> 
          At Provenance, we are uniquely positioned to operate across the full supply chain for agri-commodities. From upstream linkages of allied, supportive and competing commodities and raw material, to logistics, and finally understanding how the downstream end-products markets behave, we provide a comprehensive overview of the complexity of  commodity supply chains to make it easier to get actionable insights.
        </p>
      </div>
    </section>
  );
};

export default IntegratedCoverage;